export default __webpack_public_path__ + "static/media/wrong-number.4fd903a0.svg";